import * as React from 'react';
import { useState } from 'react';
import { Alert, Flex, Tabs, Typography } from '@duxton-web/ui';
import _ from 'lodash';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';
import { hasTridentPermission } from 'omega-rtc/utils/user-utils';
import TridentCampaignSearchView from './TridentCampaignSearchView';
import TridentCampaignVisualisationView from 'views/trident-campaigns/index/TridentCampaignVisualisationView';
import './TridentHomePage.scss';
import { Button } from 'semantic-grab-ui/src';

const CURRENT_TAB_QUERY_KEY = 'tab';
const TAB_CAMPAIGNS_KEY = 'campaigns';
const TAB_SCENARIOS_VISUALISER_KEY = 'scenarios-visualiser';

interface Props {
  location: any;
  router: any;
  userPermissions: any;
}

const TridentHomePage: React.FC<Props> = (props) => {
  const {
    location,
    router,
    userPermissions,
  } = props;

  const searchParams = location.query || {};

  const [activeTab, setActiveTab] = useState(
    _.get(searchParams, CURRENT_TAB_QUERY_KEY, TAB_CAMPAIGNS_KEY),
  );

  const handleTabClick = (currentTab: string) => {
    if (currentTab !== activeTab) {
      setActiveTab(currentTab);

      const paramsObj = new URLSearchParams(searchParams);
      paramsObj.set(CURRENT_TAB_QUERY_KEY, currentTab);
      browserHistory.push(`${location.pathname}?${paramsObj.toString()}`);
    }
  };

  // Check permissions
  const canViewCampaigns = hasTridentPermission(userPermissions, '', '', 'read');
  const canCreateEntity = hasTridentPermission(userPermissions, '', '', 'create');

  if (userPermissions && !canViewCampaigns) {
    return (
      <Alert
        message="You don't have access to Trident Campaigns"
        showIcon
        type="error"
      />
    );
  }

  const tabsMeta = [
    {
      key: TAB_CAMPAIGNS_KEY,
      label: 'Campaigns',
      children: (
        <TridentCampaignSearchView
          router={router}
          location={location}
        />
      ),
    },
    {
        key: TAB_SCENARIOS_VISUALISER_KEY,
        label: 'Scenarios Visualiser',
        children: (
            <TridentCampaignVisualisationView
              location={location}
              router={router}
            />
        )
    }
  ];

  return (
    <DocumentTitle title="Trident">
      <div className={'trident-basic'}>
        <Flex
          vertical={false}
          justify="space-between"
          style={{
            paddingBottom: '30px',
          }}
        >
          <Typography.Title level={2}>Trident</Typography.Title>

          {canCreateEntity &&
            <Button medium primary floated="right" as={Link} to={`campaigns/new`} style={
              {
                height: 40,
                borderRadius: 30
              }
            }>
              + Create campaign
            </Button>}
        </Flex>
        <div className="trident-nav">
          <Tabs
            onTabClick={handleTabClick}
            activeKey={activeTab}
            items={tabsMeta}
          />
        </div>
      </div>
    </DocumentTitle>
  );
};

// MapStateToProps function
export function mapStateToProps(state: any, ownProps: any) {
  const userPermissions = state.app.user.userPermissions;

  return {
    userPermissions,
  };
}

export default connect(mapStateToProps, {})(TridentHomePage);
